import React from 'react'
import './ButtonNav.css'

const ButtonNav = () => {
  return (
    <button className='buttonNav'></button>
  )
}

export default ButtonNav